import { FormSwitch } from 'components/form-fields';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { Fragment } from 'react';
import { Alignment } from '@blueprintjs/core';

export function OcrSwitchLayout(
    {
        loading = false,
        disabled = false,
        readonly = false,
        alignment = Alignment.START,
        label,
        layout,
        onChange
    }
) {

    function onValueChange(value) {
        const clonedLayout = { ...layout };

        clonedLayout.answer = value.currentTarget.checked ? value.currentTarget.checked : false;

        onChange(clonedLayout);
    }

    return (
        <Fragment>
            <div className={classNames({ "hide-in-print": !readonly, "hidden": readonly })}>
                <FormSwitch
                    loading={loading}
                    label={label}
                    disabled={disabled}
                    checked={layout.answer && (layout.answer === "true" || layout.answer === true)}
                    alignment={alignment}
                    onChange={onValueChange}>
                </FormSwitch>
            </div>
        </Fragment>
    );

}

OcrSwitchLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    label: PropTypes.string,
    alignment: PropTypes.string,
    onChange: PropTypes.func.isRequired
};
